import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Aria from 'formvalidation/es6/plugins/Aria';

[].forEach.call(document.querySelectorAll('.free-trial-form'), (form) => {
    formValidation(form, {
        plugins: {
            aria: new Aria(),
            bootstrap3: new Bootstrap3(),
            defaultSubmit: new DefaultSubmit(),
            submitButton: new SubmitButton(),
            declarative: new Declarative({
                html5Input: true,
            }),
        },
    }).on('core.form.valid', () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(
            {
                event: 'GAEvent',
                eventCategory: 'Forms',
                eventAction: 'Form Submitted Success',
                eventLabel: 'prior-free-trial-form',
            },
        );
        const submit = form.querySelector('button[type="submit"]');
        submit.disabled = true;
    });
});

function formatPrice(value, currency, locale) {
    const formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        notation: 'standard',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: value % 1 === 0 ? 0 : 2,
    }).format(value);

    return formatted.replace('zł', '<span class="currency">zł</span>').replace('€', '<span class="currency">€</span>').replace('$', '<sup class="currency">$</sup>');
}

const priceEl = document.querySelector('.pricing-section .formatted-price');
priceEl.innerHTML = formatPrice(priceEl.dataset.value * 1, priceEl.dataset.currency, priceEl.dataset.language);

[...document.querySelectorAll('[data-price="Free"]')].forEach((el) => {
    el.innerHTML = formatPrice(document.querySelector('[data-price="Free"]').dataset.value * 1, priceEl.dataset.currency, priceEl.dataset.language);
});
[...document.querySelectorAll('[data-price="Basic"]')].forEach((el) => {
    el.innerHTML = formatPrice(document.querySelector('[data-price="Basic"]').dataset.value * 1, priceEl.dataset.currency, priceEl.dataset.language);
});
[...document.querySelectorAll('[data-price="Plus"]')].forEach((el) => {
    el.innerHTML = formatPrice(document.querySelector('[data-price="Plus"]').dataset.value * 1, priceEl.dataset.currency, priceEl.dataset.language);
});
[...document.querySelectorAll('[data-price="Professional"]')].forEach((el) => {
    el.innerHTML = formatPrice(document.querySelector('[data-price="Professional"]').dataset.value * 1, priceEl.dataset.currency, priceEl.dataset.language);
});

[...document.querySelectorAll('.toggle-details-on')].forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        [...document.querySelectorAll('.bottom')].filter((packetEl) => packetEl.contains(e.target))[0].classList.add('details-visible');
    });
});
[...document.querySelectorAll('.toggle-details-off')].forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        [...document.querySelectorAll('.bottom')].filter((packetEl) => packetEl.contains(e.target))[0].classList.remove('details-visible');
    });
});
